/**
 * Single source of truth for the blogPost tag values, so the content model and the code cannot
 * drift apart. Plain CommonJS so `migration/blogPost.js` can require it while building the
 * Contentful `in` validation, and TypeScript can import it too — the JSDoc const assertion is
 * what keeps `BlogTag` a union across that boundary instead of widening to `string`.
 */
const BLOG_TAGS = /** @type {const} */ ([
  'tracking-tips',
  'shopping-tips',
  'trends',
  'international-shopping',
  'courier-guides',
]);

module.exports = { BLOG_TAGS };
